import { logError, logInfo, logWarn } from "@/helpers/logError";
import { createUploadTelemetry, type UploadTelemetry } from "@uploads";
import { observeDurablePreparation } from "./uploadPreparationObservation";

export const adminUploadTelemetry: UploadTelemetry = createUploadTelemetry((record) => {
	if (record.level === "error") logError(record.event, record.error, record.context);
	else if (record.level === "warn") logWarn(record.event, record.context);
	else logInfo(record.event, record.context);
	if (record.event === "recording.fileUpload.preparationFinished" && typeof record.context?.sessionId === "string") {
		const sessionId = record.context.sessionId;
		// Fire-and-forget observation: it never delays or controls upload cleanup/handoff.
		void observeDurablePreparation(async () => {
			const { db } = await import("@/db/fileUploadDb");
			return db.fileUploadChunkData.where("sessionId").equals(sessionId).count();
		}).then((observation) =>
			adminUploadTelemetry.logInfo("recording.fileUpload.preparationDurableSnapshot", { ...record.context, ...observation })
		);
	}
});
